const projects = [
  {
    id: 1,
    img: 'https://user-images.githubusercontent.com/63560332/165494817-01c99379-eac6-48cb-b587-3f1827eae82a.png',
    link: 'https://vacay-home.netlify.app/',
    title: 'Vacay Home',
    description: 'A website for a vacation rental company.',
    lang: 'React, Redux, Ruby on Rails',
    repo: 'https://github.com/adamteddychang/Vacayhome-backend',
  },
  {
    id: 2,
    img: 'https://user-images.githubusercontent.com/63560332/165489102-2e71116a-8bd6-4f7e-9c3f-2a7b7e1e9f9d.png',
    link: 'https://the--budget.herokuapp.com/',
    title: 'The Budget',
    description: 'A mobile Web application for tracking your expenses.',
    lang: 'Ruby, Ruby on Rails',
    repo: 'https://github.com/adamteddychang/The-Budget',
  },
  {
    id: 3,
    img: 'https://user-images.githubusercontent.com/63560332/165495816-859c65c7-9a61-4fc3-8b4c-bf805e24b88f.png',
    link: 'https://spacetravellers.netlify.app/',
    title: "Space Traveler's Hub",
    description: 'Web application for reserving and joining space rockets and missions.',
    lang: 'React & Redux, CSS',
    repo: 'https://github.com/adamteddychang/space-travelers',
  },
  {
    id: 4,
    img: 'https://user-images.githubusercontent.com/63560332/165498049-407d9b90-18bd-42c8-a5b3-5c435ed03336.png',
    link: 'https://cool-recipe-app.herokuapp.com/',
    title: 'Cool Recipes',
    description: 'Web Application to keep track of your favorite recipes.',
    lang: 'Ruby, Ruby on Rails',
    repo: 'https://github.com/adamteddychang/Recipe-app',
  },
  {
    id: 5,
    img: 'https://user-images.githubusercontent.com/63560332/165496360-3d834619-2476-479b-9bfe-7ba4c96b83fc.png',
    link: 'https://adamteddychang.github.io/Global_tech_summit/',
    title: 'Global Tech Summit',
    description: 'A sample landing page for a conference.',
    lang: 'HTML/CSS',
    repo: 'https://github.com/adamteddychang/Global_tech_summit',
  },
  {
    id: 6,
    img: 'https://user-images.githubusercontent.com/63560332/165499985-e8406b90-9e51-48fa-bd3d-96c9befdd87f.png',
    link: 'https://github.com/adamteddychang/school_library',
    title: 'School Library',
    description: 'A Ruby terminal application to keep track of books in a library.',
    lang: 'Ruby',
    repo: 'https://github.com/adamteddychang/school_library',
  },
];

export default projects;
